import type { LucideIcon } from 'lucide-react';

import { onlineManager } from '@tanstack/react-query';
import { Effect, Store, useStore } from '@tanstack/react-store';
import { Cloud, CloudOff } from 'lucide-react';

export type ConnectionStatusType = 'offline' | 'online';

export type ConnectionState = {
    connectionStatus: ConnectionStatusType;
};

export const CONNECTION_STATUS_ICONS = {
    offline: CloudOff,
    online: Cloud,
} as const satisfies Record<ConnectionStatusType, LucideIcon>;

export const connectionStateStore = new Store<ConnectionState>({
    connectionStatus: 'online',
});

export const useOffline = (): boolean => useStore(connectionStateStore, state => state.connectionStatus === 'offline');

export const useOnline = (): boolean => useStore(connectionStateStore, state => state.connectionStatus === 'online');

export function setConnectionStatus(state: ConnectionStatusType) {
    connectionStateStore.setState(prev => ({
        ...prev,
        connectionStatus: state,
    }));
}

export function setSheetState(state: boolean) {
    connectionStateStore.setState(prev => ({
        ...prev,
        sheetOpen: state,
    }));
}

export const lastSyncEffect = new Effect({
    fn: () => {
        if (connectionStateStore.state.connectionStatus === 'online') {
            connectionStateStore.setState(prev => ({
                ...prev,
                lastSynced: new Date(),
            }));
        }
    },
    deps: [connectionStateStore],
});

onlineManager.subscribe((isOnline) => {
    if (isOnline) {
        setConnectionStatus('online');
    }
    else {
        setConnectionStatus('offline');
    }
});
